import React from'react';import PropTypes from'prop-types';import styles from"./style";/**
 * Wraps a single filter page item.
 * @param {Object} props The component props.
 * @returns {JSX}
 */var FilterItem=function FilterItem(_ref){var children=_ref.children;return React.createElement("div",{className:styles},children);};export default FilterItem;